import React, {
    useEffect,
    useRef,
    useState
} from "react";

import {
    ArrowLeftOutlined,
    CompressOutlined,
    ExpandOutlined,
    ReloadOutlined
} from "@ant-design/icons";

import {
    useNavigate
} from "react-router-dom";

import {
    renderAsync
} from "docx-preview";

import {
    getDocxReaderBuffer,
    getReaderFolder,
    getReaderFolderFileBlob
} from "../api/myBook";


export default function DocxLabView({
    slug,
    title
}) {

    const navigate =
        useNavigate();

    const contentRef =
        useRef(null);

    const wrapperRef =
        useRef(null);

    const [loading, setLoading] =
        useState(true);

    const [error, setError] =
        useState("");

    const [reloadKey, setReloadKey] =
        useState(0);

    const [fullscreen, setFullscreen] =
        useState(false);

    const [internalPdfUrl, setInternalPdfUrl] =
        useState("");

    const [internalPdfName, setInternalPdfName] =
        useState("");

    const [folderFiles, setFolderFiles] =
        useState([]);

    const [folderLoading, setFolderLoading] =
        useState(false);


    useEffect(() => {

        const onFullscreen =
            () =>
                setFullscreen(
                    Boolean(
                        document.fullscreenElement
                    )
                );

        document.addEventListener(
            "fullscreenchange",
            onFullscreen
        );

        return () =>
            document.removeEventListener(
                "fullscreenchange",
                onFullscreen
            );

    }, []);


    useEffect(() => {

        let alive =
            true;

        const load =
            async () => {

                try {

                    setLoading(true);
                    setError("");

                    const result =
                        await getDocxReaderBuffer(
                            slug
                        );

                    if (!alive) {
                        return;
                    }

                    const type =
                        String(
                            result.contentType ||
                            ""
                        ).toLowerCase();

                    if (
                        !type.includes(
                            "wordprocessingml"
                        ) &&
                        !type.includes(
                            "application/octet-stream"
                        )
                    ) {
                        throw new Error(
                            "File này không phải DOCX. Content-Type: " +
                            type
                        );
                    }

                    if (
                        !contentRef.current
                    ) {
                        return;
                    }

                    contentRef.current.innerHTML =
                        "";

                    await renderAsync(
                        result.data,
                        contentRef.current,
                        null,
                        {
                            className:
                                "docx",

                            inWrapper:
                                true,

                            breakPages:
                                true,

                            ignoreWidth:
                                false,

                            ignoreHeight:
                                false,

                            ignoreFonts:
                                false,

                            useBase64URL:
                                true
                        }
                    );


                    const links =
                        contentRef.current
                            .querySelectorAll(
                                "a"
                            );

                    links.forEach(
                        link => {

                            const href =
                                String(
                                    link.getAttribute(
                                        "href"
                                    ) || ""
                                );

                            const isDriveFolder =
                                /drive\.google\.com\/(?:drive\/)?folders\//i
                                    .test(
                                        href
                                    );

                            /*
                             * Link Drive Folder:
                             * GIU BAM DUOC, nhung mo noi bo.
                             */
                            if (
                                isDriveFolder
                            ) {

                                link.removeAttribute(
                                    "target"
                                );

                                link.style.pointerEvents =
                                    "auto";

                                link.style.cursor =
                                    "pointer";

                                link.addEventListener(
                                    "click",
                                    async event => {

                                        event.preventDefault();
                                        event.stopPropagation();

                                        try {

                                            setFolderLoading(
                                                true
                                            );

                                            const result =
                                                await getReaderFolder(
                                                    slug,
                                                    href
                                                );

                                            const files =
                                                result?.data?.files ||
                                                [];

                                            if (
                                                files.length === 0
                                            ) {
                                                throw new Error(
                                                    "Không tìm thấy PDF trong thư mục."
                                                );
                                            }

                                            if (
                                                files.length === 1
                                            ) {

                                                const blob =
                                                    await getReaderFolderFileBlob(
                                                        files[0].url
                                                    );

                                                const objectUrl =
                                                    URL.createObjectURL(
                                                        blob
                                                    );

                                                setInternalPdfName(
                                                    files[0].name ||
                                                    "Tài liệu PDF"
                                                );

                                                setInternalPdfUrl(
                                                    objectUrl
                                                );

                                                return;
                                            }

                                            setFolderFiles(
                                                files
                                            );

                                        } catch (error) {

                                            console.error(
                                                "FOLDER LINK ERROR:",
                                                error
                                            );

                                            alert(
                                                error?.response
                                                    ?.data
                                                    ?.message ||
                                                error?.message ||
                                                "Không mở được tài liệu."
                                            );

                                        } finally {

                                            setFolderLoading(
                                                false
                                            );
                                        }
                                    }
                                );

                                return;
                            }

                            /*
                             * Link ngoai khac van bi vo hieu hoa,
                             * tranh day khach khoi OS BOOKS.
                             */
                            link.removeAttribute(
                                "href"
                            );

                            link.removeAttribute(
                                "target"
                            );

                            link.style.pointerEvents =
                                "none";

                            link.style.cursor =
                                "default";
                        }
                    );

                    if (alive) {
                        setLoading(false);
                    }

                } catch (err) {

                    console.error(
                        "DOCX LAB ERROR:",
                        err
                    );

                    if (alive) {

                        setLoading(false);

                        setError(
                            err?.message ||
                            "Không thể mở DOCX."
                        );
                    }
                }
            };

        load();

        return () => {
            alive =
                false;
        };

    }, [
        slug,
        reloadKey
    ]);


    const toggleFullscreen =
        async () => {

            try {

                if (
                    document.fullscreenElement
                ) {
                    await document
                        .exitFullscreen();

                    return;
                }

                if (
                    wrapperRef.current
                        ?.requestFullscreen
                ) {
                    await wrapperRef
                        .current
                        .requestFullscreen();
                }

            } catch (err) {

                console.log(
                    "Fullscreen error:",
                    err
                );
            }
        };


    if (
        internalPdfUrl
    ) {
        return (
            <div
                className="
                    fixed
                    inset-0
                    z-[100000]
                    flex
                    flex-col
                    bg-[#202124]
                "
            >
                <div
                    className="
                        h-[58px]
                        flex-none
                        flex
                        items-center
                        gap-3
                        px-4
                        bg-[#17191c]
                        text-white
                        border-b
                        border-white/10
                    "
                >
                    <button
                        type="button"
                        onClick={() => {
                            URL.revokeObjectURL(
                                internalPdfUrl
                            );

                            setInternalPdfUrl(
                                ""
                            );

                            setInternalPdfName(
                                ""
                            );
                        }}
                        className="
                            px-3
                            h-9
                            rounded-lg
                            hover:bg-white/10
                            font-semibold
                        "
                    >
                        ← TÀI LIỆU
                    </button>

                    <div
                        className="
                            flex-1
                            truncate
                            font-semibold
                        "
                    >
                        {internalPdfName}
                    </div>
                </div>

                <iframe
                    src={internalPdfUrl}
                    title={
                        internalPdfName ||
                        "PDF"
                    }
                    className="
                        flex-1
                        w-full
                        border-0
                        bg-[#202124]
                    "
                />
            </div>
        );
    }


    return (

        <div
            ref={wrapperRef}
            className="
                fixed
                inset-0
                z-[99999]
                flex
                flex-col
                bg-[#202124]
            "
        >

            <header
                className="
                    h-[58px]
                    flex-none
                    flex
                    items-center
                    gap-2
                    px-3
                    md:px-4
                    bg-[#17191c]
                    border-b
                    border-white/10
                    text-white
                "
            >

                <button
                    type="button"
                    onClick={() =>
                        navigate(-1)
                    }
                    className="
                        h-9
                        px-3
                        rounded-lg
                        flex
                        items-center
                        gap-2
                        hover:bg-white/10
                    "
                >
                    <ArrowLeftOutlined />

                    <span
                        className="
                            hidden
                            sm:inline
                            font-semibold
                            text-sm
                        "
                    >
                        THƯ VIỆN
                    </span>
                </button>


                <div
                    className="
                        flex-1
                        min-w-0
                    "
                >

                    <div
                        className="
                            truncate
                            font-semibold
                            text-sm
                            md:text-[15px]
                        "
                    >
                        {title ||
                            "Tài liệu"}
                    </div>

                    <div
                        className="
                            hidden
                            sm:block
                            text-[10px]
                            text-gray-400
                        "
                    >
                        Đang đọc trực tuyến
                    </div>

                </div>


                <button
                    type="button"
                    onClick={() =>
                        setReloadKey(
                            value =>
                                value + 1
                        )
                    }
                    className="
                        w-9
                        h-9
                        rounded-lg
                        hover:bg-white/10
                    "
                    title="Tải lại"
                >
                    <ReloadOutlined />
                </button>


                <button
                    type="button"
                    onClick={
                        toggleFullscreen
                    }
                    className="
                        w-9
                        h-9
                        rounded-lg
                        hover:bg-white/10
                    "
                    title="Toàn màn hình"
                >
                    {fullscreen
                        ? <CompressOutlined />
                        : <ExpandOutlined />
                    }
                </button>

            </header>


            <main
                className="
                    relative
                    flex-1
                    min-h-0
                    overflow-auto
                    bg-[#303030]
                    py-5
                    px-2
                    md:px-5
                "
            >

                {loading && (

                    <div
                        className="
                            fixed
                            inset-0
                            top-[58px]
                            z-20
                            flex
                            items-center
                            justify-center
                            bg-[#202124]
                            text-gray-300
                        "
                    >
                        Đang mở tài liệu DOCX...
                    </div>
                )}


                {folderLoading && (
                    <div
                        className="
                            fixed
                            inset-0
                            z-30
                            flex
                            items-center
                            justify-center
                            bg-black/60
                            text-white
                        "
                    >
                        Đang mở tài liệu...
                    </div>
                )}


                {folderFiles.length > 1 && (
                    <div
                        className="
                            fixed
                            inset-0
                            z-40
                            flex
                            items-center
                            justify-center
                            bg-black/70
                            p-4
                        "
                    >
                        <div
                            className="
                                w-full
                                max-w-[560px]
                                max-h-[75vh]
                                overflow-auto
                                rounded-2xl
                                bg-white
                                p-5
                                shadow-2xl
                            "
                        >
                            <div
                                className="
                                    text-lg
                                    font-semibold
                                "
                            >
                                Chọn tài liệu
                            </div>

                            <div
                                className="
                                    mt-4
                                    space-y-2
                                "
                            >
                                {folderFiles.map(
                                    file => (
                                        <button
                                            key={
                                                file.id
                                            }
                                            type="button"
                                            onClick={
                                                async () => {
                                                    try {
                                                        setFolderLoading(
                                                            true
                                                        );

                                                        const blob =
                                                            await getReaderFolderFileBlob(
                                                                file.url
                                                            );

                                                        const objectUrl =
                                                            URL.createObjectURL(
                                                                blob
                                                            );

                                                        setInternalPdfName(
                                                            file.name
                                                        );

                                                        setInternalPdfUrl(
                                                            objectUrl
                                                        );

                                                        setFolderFiles(
                                                            []
                                                        );

                                                    } finally {
                                                        setFolderLoading(
                                                            false
                                                        );
                                                    }
                                                }
                                            }
                                            className="
                                                block
                                                w-full
                                                rounded-xl
                                                border
                                                border-gray-200
                                                p-4
                                                text-left
                                                hover:bg-gray-50
                                            "
                                        >
                                            {file.name}
                                        </button>
                                    )
                                )}
                            </div>

                            <button
                                type="button"
                                onClick={() =>
                                    setFolderFiles(
                                        []
                                    )
                                }
                                className="
                                    mt-4
                                    rounded-lg
                                    px-4
                                    py-2
                                    bg-gray-100
                                "
                            >
                                Đóng
                            </button>
                        </div>
                    </div>
                )}


                {error && (

                    <div
                        className="
                            mx-auto
                            mt-14
                            max-w-[560px]
                            rounded-xl
                            bg-white
                            p-6
                            shadow-xl
                        "
                    >

                        <div
                            className="
                                text-lg
                                font-semibold
                                text-red-600
                        "
                        >
                            Không mở được tài liệu
                        </div>

                        <div
                            className="
                                mt-3
                                text-sm
                                text-gray-600
                            "
                        >
                            {error}
                        </div>

                    </div>
                )}


                <div
                    ref={contentRef}
                    className="
                        os-docx-reader
                        mx-auto
                    "
                />

            </main>


            <style>
                {`
                .os-docx-reader .docx-wrapper {
                    background: transparent !important;
                    padding: 0 !important;
                }

                .os-docx-reader .docx-wrapper > section.docx {
                    margin: 0 auto 20px !important;
                    box-shadow:
                        0 8px 30px rgba(0,0,0,.32);
                }

                .os-docx-reader a {
                    pointer-events: none !important;
                    cursor: default !important;
                    text-decoration: none !important;
                    color: inherit !important;
                }
                `}
            </style>

        </div>
    );
}
